import { Checkbox } from 'blaze-ui/Checkbox/Checkbox'

import Avatar from 'common/Avatar/Avatar'
import Styles from './InviteTeam.module.scss'

export interface GoogleContact {
  email: string
  name: string
  url: string
}

interface ImportUserRowProps {
  onCheck: (user: GoogleContact) => void
  selected: boolean
  user: GoogleContact
}

const ImportUserRow = ({ user, selected, onCheck }: ImportUserRowProps) => {
  const { name, email, url } = user

  return (
    <div className={Styles.userRow} onClick={() => onCheck(user)}>
      <div className={Styles.userData}>
        <Avatar size={32} url={url} />
        <div className={Styles.contactInfo}>
          <div className={Styles.name}>{name}</div>
          <div className={Styles.email}>{email}</div>
        </div>
      </div>
      <Checkbox aria-label={email} isSelected={selected} onChange={() => onCheck(user)} />
    </div>
  )
}

export default ImportUserRow
